import { useState, useRef, useEffect } from "react";
import {
    db,
    doc,
    updateDoc,
} from "./firebase"; // Ajusta según tu configuración
import { toast } from "react-toastify"; // Ejemplo usando react-toastify (opcional)



function responderPorCanal(channel, recipientId, message) {
    if (channel === "Telegram") {
        const telegramUrl = `https://api.telegram.org/bot7878413507:AAFtqr0Qd392CJoUs5G7JpPoeKyUgBtzzB8/sendMessage`;
        const body = {
            chat_id: recipientId,
            text: message
        };
        fetch(telegramUrl, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(body)
        });
        console.log(`Mensaje enviado a Telegram (chat_id: ${recipientId}).`);
    } else if (channel === "WhatsApp") {
        const whatsAppUrl = `https://v3xvwv.api.infobip.com/whatsapp/1/message/text`;
        fetch(whatsAppUrl, {
            method: "POST",
            headers: {
                'Authorization': 'App 77b973f0fa17e1f6c49175d44b529718-df43d4da-51e6-4e7b-8ba2-aca8cb3dd5c5',
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({ "from": "12244011005", "to": recipientId, "content": { "text": message } })
        });
        console.log(`Mensaje enviado a WhatsApp (chat_id: ${recipientId}).`);
    } else {
        console.log(`No hay implementación para el canal: ${channel}. Mensaje: ${message}`);
        // Podrías manejar otros canales (WhatsApp, SMS, etc.) con un else-if
    }
}


export default function ConversationCard({ conversation }) {
    const {
        id,
        personName,
        personId,
        createdAt,
        lastUpdate,
        historyChat,
        channel,
        personFullName,
        conversationStatus,
    } = conversation;

    // Modal para enviar mensaje
    const [showSendModal, setShowSendModal] = useState(false);
    // Texto del mensaje
    const [messageText, setMessageText] = useState("");

    // Modal para ver la conversación completa
    const [showModal, setShowModal] = useState(false);

    // Ref para el contenedor de historial (para auto-scroll)
    const chatContainerRef = useRef(null);

    // Efecto para scrollear al final cada vez que cambie el historial
    useEffect(() => {
        if (chatContainerRef.current) {
            chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
        }
    }, [historyChat]);

    // Cálculo de "reciente"
    const now = Date.now();
    const diff = now - lastUpdate;
    const isRecent = diff < 1800000;
    const badgeClass = isRecent ? "bg-[#5860D5] text-white" : "bg-[#e91c24] text-white";

    // Maneja el envío del mensaje
    const handleSendMessage = async () => {
        // Evitamos mandar si está vacío por alguna razón extra
        if (!messageText.trim()) return;

        try {
            // Actualizamos el documento en Firestore
            const conversationRef = doc(db, "activeUsersMayorista", id);
            await updateDoc(conversationRef, {
                historyChat: [
                    ...historyChat,
                    {
                        // Usamos 'agent' para diferenciar que el mensaje lo envía el agente 
                        agent: messageText,
                        timestamp: Date.now(),
                    },
                ],
                lastUpdate: Date.now(),
            });

            responderPorCanal(channel, personId, messageText)

            // Restablecemos la caja de texto y cerramos el modal
            setMessageText("");
            setShowSendModal(false);

            // MOSTRAR NOTIFICACIÓN de éxito (3) -------------
            // Ejemplo con react-toastify (instala: npm install react-toastify)
            toast.success("Mensaje enviado correctamente!");

        } catch (error) {
            console.error("Error enviando el mensaje:", error);
            toast.error("Hubo un error al enviar el mensaje");
        }
    };

    return (
        <>
            {/* Tarjeta principal */}
            <div className="card bg-base-100 shadow-xl">
                <div className="card-body">
                    <h2 className="card-title">
                        {personName}
                        {/* Clic en el badge para abrir modal de envío */}
                        <div
                            className={`badge ml-2 text-xs cursor-pointer ${badgeClass}`}
                            onClick={() => setShowSendModal(true)}
                            title="Haz clic para enviar un mensaje a esta persona"
                        >
                            ID: {personId}
                        </div>
                        {/* Si existe conversationStatus, se muestra un badge adicional */}
                        {conversationStatus && (
                            <div className="badge badge-info ml-2 text-xs">
                                {conversationStatus}
                            </div>
                        )}
                    </h2>
                    <p className="text-sm text-gray-500">
                        Creado: {new Date(createdAt).toLocaleString()}
                    </p>
                    <p className="text-sm text-gray-500">
                        Último: {new Date(lastUpdate).toLocaleString()}
                    </p>

                    {/* Historial (clic para ver todo en un modal grande) */}
                    <div
                        ref={chatContainerRef}
                        className="mt-2 max-h-40 overflow-auto space-y-2 cursor-pointer"
                        onClick={() => setShowModal(true)}
                        title="Haz clic para ver la conversación completa"
                    >
                        {historyChat?.map((msg, idx) => {
                            // Distintos roles: user, bot o agent
                            const isUser = !!msg.user;
                            const isAgent = !!msg.agent;
                            const content = msg.user || msg.bot || msg.agent;
                            const dateString = new Date(msg.timestamp).toLocaleString();

                            // Determinamos quién es el emisor (texto)
                            let senderText = "Bot";
                            if (isUser) senderText = "Usuario";
                            if (isAgent) senderText = "Agente";

                            return (
                                <div
                                    key={idx}
                                    className={`p-2 rounded-md w-fit max-w-[80%] ${isUser
                                        ? "bg-blue-50 text-blue-800 ml-auto"
                                        : isAgent
                                            ? "bg-green-50 text-green-800 mr-auto"
                                            : "bg-gray-100 text-gray-800 mr-auto"
                                        }`}
                                >
                                    <div className="text-xs font-semibold">
                                        {senderText}
                                    </div>
                                    <div className="text-sm whitespace-pre-wrap">{content}</div>
                                    <div className="text-xs text-gray-500 text-right mt-1">
                                        {dateString}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>

            {/* Modal para ver la conversación completa */}
            {showModal && (
                <div className="modal modal-open">
                    <div className="modal-box max-w-3xl">
                        <h3 className="font-bold text-lg mb-4">
                            Conversación completa: {personFullName}
                        </h3>
                        <div className="max-h-[70vh] overflow-auto space-y-3">
                            {historyChat?.map((msg, idx) => {
                                // Repetimos la lógica de roles
                                const isUser = !!msg.user;
                                const isAgent = !!msg.agent;
                                const content = msg.user || msg.bot || msg.agent;
                                const dateString = new Date(msg.timestamp).toLocaleString();

                                let senderText = "Bot";
                                if (isUser) senderText = "Usuario";
                                if (isAgent) senderText = "Agente";

                                return (
                                    <div
                                        key={idx}
                                        className={`p-3 rounded-md w-fit max-w-[80%] ${isUser
                                            ? "bg-blue-50 text-blue-800 ml-auto"
                                            : isAgent
                                                ? "bg-green-50 text-green-800 mr-auto"
                                                : "bg-gray-100 text-gray-800 mr-auto"
                                            }`}
                                    >
                                        <div className="text-xs font-semibold">
                                            {senderText}
                                        </div>
                                        <div className="text-sm whitespace-pre-wrap">{content}</div>
                                        <div className="text-xs text-gray-500 text-right mt-1">
                                            {dateString}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>

                        <div className="modal-action">
                            <button className="btn" onClick={() => setShowModal(false)}>
                                Cerrar
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal para enviar un mensaje (clic en ID) */}
            {showSendModal && (
                <div className="modal modal-open">
                    <div className="modal-box">
                        <h3 className="font-bold text-lg mb-4">
                            Enviar mensaje a {personFullName}
                        </h3>

                        {/* Caja de texto */}
                        <textarea
                            className="textarea textarea-bordered w-full"
                            placeholder="Escribe tu mensaje aquí..."
                            value={messageText}
                            onChange={(e) => setMessageText(e.target.value)}
                        />

                        <div className="modal-action">
                            <button className="btn" onClick={() => setShowSendModal(false)}>
                                Cancelar
                            </button>
                            {/* (1) Deshabilitar si está vacío */}
                            <button
                                className="btn btn-primary"
                                onClick={handleSendMessage}
                                disabled={!messageText.trim()}
                            >
                                Enviar
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

